export { default } from './svg/no-image.svg';
